/* Skipped in the theme editor, which scrolls the preview programmatically. Overlays that
 * scroll themselves are excluded below; anything else can opt out with data-lenis-prevent. */
(() => {
  if (window.Shopify?.designMode) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (typeof Lenis === 'undefined') return;

  window.lenis = new Lenis({
    autoRaf: true,
    anchors: true,
    prevent: (node) =>
      node instanceof Element &&
      (node.tagName === 'DIALOG' ||
        node.classList.contains('header__megamenu') ||
        node.classList.contains('header__mobile-menu') ||
        node.classList.contains('disclosure__list') ||
        node.classList.contains('facets-filters-form__fieldset') ||
        // Klaviyo Customer Hub (account) drawer, injected by the Klaviyo app.
        node.classList.contains('kl-hub-drawer') ||
        node.classList.contains('kl-hub-modal-veil')),
  });
})();
